import { cn } from '../../lib/utils';
import useI18n from '../../hooks/useI18n';

export type PaginationCounterProps = {
  /** Current page, 1-based. */
  page: number;
  pageSize: number;
  totalItems: number;
  className?: string;
};

/** Shows which slice of the items is visible, e.g. "1-50 of 123". */
export function PaginationCounter({
  page,
  pageSize,
  totalItems,
  className,
}: PaginationCounterProps) {
  const { t } = useI18n();

  if (totalItems <= 0) return null;

  return (
    <div className={cn('eye:body-s', className)}>
      {t('tableRowsCounter', {
        from: (page - 1) * pageSize + 1,
        to: Math.min(totalItems, page * pageSize),
        total: totalItems,
      })}
    </div>
  );
}
